import React from "react";
import { DynamicFieldStyle1 as InputWithIconAndLabel } from "sites-common/components/DynamicField";
import { Box } from "theme-ui";
import PropTypes from "prop-types";
import { formatToIST } from "../RecurringDonations/utils";
import { DayPickerInput } from "../..";

const DonationByCheque = ({ compare }) => {
  const [cheque, onChange] = compare;
  const { chequeNo, chequeDate, chequeBankName } = cheque;

  const dayPickerInputProps = React.useMemo(
    () => ({
      value: chequeDate,
      formatDate: formatToIST,
      inputProps: {
        readOnly: true,
      },
      dayPickerProps: {
        onDayClick: (e, { disabled }) => !disabled && onChange(e, "chequeDate"),
        modifiers: {
          disabled: {
            before: "",
          },
        },
      },
    }),
    [chequeDate, onChange]
  );

  return (
    <Box sx={{ mb: "0px !important" }}>
      <Box
        sx={{
          fontSize: "12px",
          backgroundColor: "background2",
          padding: "7px",
          margin: "0px !important",
        }}
      >
        Please fill the below details, The instructions to send cheque will be
        emailed to you
      </Box>
      <InputWithIconAndLabel
        name="Cheque Number"
        inputTransform={(r) => r.toUpperCase()}
        value={chequeNo}
        variant="border-bottom"
        type="text"
        label="Cheque Number"
        onChange={(e) => onChange(e, "chequeNo")}
      />
      <DayPickerInput
        {...dayPickerInputProps}
        label="Cheque Dated"
        inputProps={{
          readOnly: true,
          variant: "border-bottom",
        }}
      />
      <InputWithIconAndLabel
        inputTransform={(r) => r.toUpperCase()}
        variant="border-bottom"
        name="Bank Name"
        value={chequeBankName}
        type="text"
        label="Cheque: Bank Name"
        onChange={(e) => onChange(e, "chequeBankName")}
      />
    </Box>
  );
};

DonationByCheque.propTypes = {
  compare: PropTypes.shape({}).isRequired,
};

export default React.memo(DonationByCheque);
